import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import "./FileInput.css";

export type FileInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "type"
>;

/**
 * The file picker. Pass `hidden` and a ref to open it from your own Button
 * (ref.current.click()); without `hidden` it shows the browser's file field
 * with the shared look.
 * Example: <FileInput ref={ref} hidden accept="application/pdf" onChange={onPick} />
 */
const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ className = "", ...rest }, ref) => (
    <input
      ref={ref}
      type="file"
      className={`ds-file-input ${className}`.trim()}
      {...rest}
    />
  )
);

FileInput.displayName = "FileInput";

export default FileInput;
